module.exports = __webpack_public_path__ + "static/img/bot-step-3.b8bfb26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-3.png
// module id = RmsR
// module chunks = 11